/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function navigateBack(params, context) {
    // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
    var formatInput = function (options) {
        var _a;
        return ({
            backData: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
        });
    };
    context.WVCall('CNHybridNavigator.goBack', params, { formatInput: formatInput });
}

export { navigateBack as default };
